export const blue = '#0f578d';
export const disabledGreen = '#dcf5c1';
export const green = '#8bc740'